<template>
  <iframe id="blog-frame" frameBorder="0" src="https://info.enter.hetnieuweinstituut.nl/blog"></iframe>
</template>

<script>
export default {

}
</script>

<style>
iframe {
  width:min(1000px, 100%);
  height:100%;
  filter: var(--drop-shadow);
}
</style>